import React from "react";
import { FaShieldAlt } from "react-icons/fa"; // Mission icon
import { FaLeaf } from "react-icons/fa6"; // Vision icon
import aboutImage from "../assets/about.webp";
import greenStar from "../assets/shapes/green-star.png";
import blackStar from "../assets/shapes/black-star.png";
import greenArrow from "../assets/shapes/left-green-arrow.png";

const BetterTomorrow = () => {
  return (
    <section className="w-full bg-white sm:py-12 py-[24px] px-[16px] sm:px-6 md:px-12 lg:px-20 relative overflow-x-hidden">
      <img
        src={greenStar}
        className="absolute top-[10%] right-[-1%] sm:h-16 sm:w-16 w-10 h-10"
        alt="green starr shape"
      />
      <div className="max-w-[1380px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Left Side - Image */}
        <div className="flex justify-center items-center ">
          <div className="relative">
            <img
              src={greenArrow}
              className="absolute top-[-4%] right-[-4%] w-7 h-7"
              alt="green starr shape"
            />
            <img
              src={aboutImage}
              alt="Charity"
              className=" max-w-full md:max-w-md z-[10"
            />
            <img
              src={blackStar}
              className="absolute bottom-[-6%] left-[-3%] sm:h-16 sm:w-16 w-10 h-10 z-0"
              alt="green starr shape"
            />
          </div>
        </div>

        {/* Right Side - Content */}
        <div className="flex flex-col gap-6">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug text-justify">
            Together, We Build a Better Tomorrow
          </h2>
          <p className="text-gray-600 text-sm md:text-base leading-relaxed text-justify">
            At Khadim Welfare Foundation (KWF), we believe that compassion
            paired with action can change lives. Join hands with us to uplift
            the vulnerable and transform communities across Pakistan.
          </p>

          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Mission */}
            <div className="flex flex-col gap-3 p-4 bg-[#edf7f5] rounded-md shadow-sm">
              <div className="flex items-center gap-2 text-primary-green font-semibold">
                <FaShieldAlt size={24} className="text-lg" />
                <span className="text-lg font-bold">Our Mission</span>
              </div>
              <p className="text-gray-600 text-sm text-justify">
                To uplift and support society’s most vulnerable members, serving
                humanity with love and respect, without discrimination.
              </p>
            </div>

            {/* Vision */}
            <div className="flex flex-col gap-3 p-4 bg-[#edf7f5] rounded-md shadow-sm">
              <div className="flex items-center gap-2 text-primary-green font-semibold">
                <FaLeaf size={24} className="text-lg" />
                <span className="text-lg font-bold">Our Vision</span>
              </div>
              <p className="text-gray-600 text-sm text-justify">
                To create a world where every individual has equal opportunities
                to thrive and live with dignity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetterTomorrow;
